// 'Výběr redakce'

import * as Sentry from '@sentry/browser';
import { FlashMessage } from '@components';
import * as els from './forumElements';
import * as api from './forumApi';

enum Tip {
  Rated = 't',
  NotRated = 'f',
}

interface ResponseSuccess {
  status: string;
  tip: Tip.Rated | Tip.NotRated;
}

const CLASS_BUTTON_RATED = 'forum__comment-head-tip--rated';

export const forumAdminTip = () => {
  // Pro všechny tlačítk '+/- Výběr redakce'
  els.buttonsAdminTip.forEach((button) => {
    // Po kliknutí
    button.addEventListener('click', () => {
      const { threadId, adminTip: msg, adminTipState: state } = button.dataset;
      if (!state) return;

      // Odeslat požadavek
      if (msg && threadId) {
        // U této routy nelze připravit jako formData
        fetch(`${api.tip(threadId, state)}?tip=${msg.toString()}`, {
          method: 'GET',
        })
          .then((response) => response.json())
          .then(async (data: ResponseSuccess) => {
            const hasRating = data.tip === Tip.Rated;
            const arrow: HTMLElement | null = button.querySelector('span > span');
            const rotate = 'rotate(180deg)';
            switch (data.status) {
              case '1':
                // Reloadovat tlačítko
                button.dataset.adminTipState = data.tip;
                button.classList.toggle(CLASS_BUTTON_RATED);
                if (arrow) arrow.style.transform = arrow.style.transform !== rotate ? rotate : '';

                // Informovat uživatele
                await FlashMessage({
                  msg: `Příspěvek byl ${hasRating ? 'přidán do' : 'odebrán z'} výběru redakce.`,
                  type: 'success',
                });
                break;
              default:
                throw new Error('Server nevrátil odpověď.');
            }
          })
          .catch(async (errMsg: string) => {
            Sentry.captureException(errMsg);
            await FlashMessage({
              msg: `Akci se nepodařilo provést. ${errMsg}`,
              type: 'error',
            });
          });
      }
    });
  });
};
